<template>
    <div>
        <div style="width:100%;padding-top:4px;margin:0px;" v-if="sliderData.length > 0">
            <!-- Jssor Slider Begin -->
            <div ref="sliderA"
                style="position: relative; top: 0px; left: 0px; width: 809px; height: 150px; overflow: hidden;">
                <!-- Slides Container -->
                <div u="slides"
                    style="cursor: move; position: absolute; left: 0px; top: 0px; width:809px; height:150px; overflow: hidden;">
                    <div v-for="slide in sliderData">
                        <div
                            style="position:absolute;width:100%;height:100%;top:0;left:0;text-align:center;border:1px solid #d9edf7">
                            <img style="height:100%;width:auto;" :src="slide.path" />
                        </div>
                    </div>
                </div>

                <div data-u="arrowleft" class="jssora051" style="width:55px;height:55px;top:0px;left:25px;"
                    data-autocenter="2" data-scale="0.75" data-scale-left="0.75">
                    <svg viewBox="0 0 16000 16000" style="position:absolute;top:0;left:0;width:100%;height:100%;">
                        <polyline class="a" points="11040,1920 4960,8000 11040,14080 "></polyline>
                    </svg>
                </div>
                <div data-u="arrowright" class="jssora051" style="width:55px;height:55px;top:0px;right:25px;"
                    data-autocenter="2" data-scale="0.75" data-scale-right="0.75">
                    <svg viewBox="0 0 16000 16000" style="position:absolute;top:0;left:0;width:100%;height:100%;">
                        <polyline class="a" points="4960,1920 11040,8000 4960,14080 "></polyline>
                    </svg>
                </div>

            </div>
            <!-- Jssor Slider End -->
        </div>

        <div class="col-xs-12">
            <!-- Jssor Slider Begin -->
            <div ref="sliderB" class="agx-container ags-slider-wrapper">
                <!-- Slides Container -->
                <div u="slides" class="slideContainerDiv"
                    style="cursor: move; position: absolute; left: 0px; top: 0px; width: 100px; height:100px; overflow: hidden;">
                </div>
            </div>
            <!-- Jssor Slider End -->
        </div>
    </div>
</template>
<script>

export default {
    props: {
        sliderData: { type: Array, default: [] }
    },
    data: function () {
        return {
            jdrInst: null
        };
    },
    methods: {
        genSlider: function () {
            // Code that will run only after the
            // entire view has been re-rendered
            if (this.sliderData.length > 0 && !this.sliderLoaded) {
                this.sliderLoaded = true;
                this.jdrInst = jdr.ScaleSlider.genCarouselPopup({
                    containerSelector: this.$refs.sliderA,
                    sliderTmplSelector: this.$refs.sliderB,
                    data: this.sliderData
                });
            }
        }
    },
    updated: function () {
        this.$nextTick(function () {
            this.genSlider();
        });
    },
    mounted: function () {
    },
    destroyed: function () {
        if (this.jdrInst !== null) {
            this.jdrInst.destroy();
        }
    }
}
</script>